import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

function WorkOrderDetailsPage() {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.push('/app/movements/workOrders');
    }
  }, [match]);

  return null;
}

export default WorkOrderDetailsPage;
